import type { BuildImageUrl } from '@maestro/commerce-blocks/components/image-product/image-product.types'

import { converterUrl } from '@maestro/commerce-blocks/utils/image.utils'
import { theme } from '@maestro/local/theme'

export function buildImageUrl({
  src,
  width,
  height,
  quality = theme().images.quality,
  canvas,
  backgroundColor,
  fit,
  ratio,
}: BuildImageUrl): string {
  if (theme().images.localAssetImages.includes(src)) {
    return src
  }
  const { defaultImageRatio } = theme().images
  const resolvedHeight =
    height ?? Math.round(width / (ratio || defaultImageRatio))

  return converterUrl(src, {
    quality,
    width,
    height: resolvedHeight,
    ...(fit && { fit }),
    ...(backgroundColor && { 'bg-color': backgroundColor }),
    ...(canvas && { canvas }),
  })
}
